import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable()
export class MaintenanceService {

    inMaintenance = false;

    constructor(
        private router: Router
    ) {}

    setMaintenance(): void {
        this.inMaintenance = true;

        // Send the user back to the public deals page after logout
        this.router.navigate(['maintenance']);
    }
}
